import { cx } from './cx';
import { Text } from './Text';

export type StatusTone = 'success' | 'warning' | 'error' | 'neutral' | 'brand';
export type StatusDotSize = 'sm' | 'md';

const toneClasses: Record<StatusTone, string> = {
  success: 'bg-success',
  warning: 'bg-warning',
  error: 'bg-error',
  neutral: 'bg-fg-muted',
  brand: 'bg-brand-solid',
};

export interface StatusDotProps {
  tone?: StatusTone;
  size?: StatusDotSize;
  /** Soft pulsing halo — for live/in-progress states. */
  pulse?: boolean;
  /** Optional trailing label. */
  label?: string;
  className?: string;
}

/**
 * A status dot — the shared health/status indicator (ArgoCD sync, environment
 * health, lifecycle, run state). Optionally pulses and carries a label.
 */
export const StatusDot = ({
  tone = 'neutral',
  size = 'md',
  pulse = false,
  label,
  className,
}: StatusDotProps) => {
  const dot = size === 'sm' ? 'size-1.5' : 'size-2';
  return (
    <span className={cx('inline-flex items-center gap-1.5', className)}>
      <span className="relative inline-flex">
        {pulse && (
          <span
            className={cx(
              'absolute inline-flex h-full w-full animate-ping rounded-full opacity-60',
              toneClasses[tone],
            )}
          />
        )}
        <span className={cx('relative rounded-full', dot, toneClasses[tone])} />
      </span>
      {label && (
        <Text variant="caption" tone="tertiary">
          {label}
        </Text>
      )}
    </span>
  );
};
